"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "game-setup-detail",
    class: "game-setup-detail-container"
};
const _hoisted_2 = { class: "setup-item" };
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = ["href"];
const _hoisted_6 = ["href"];
const _hoisted_7 = ["href"];
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = ["href"];
const _hoisted_12 = ["href"];
const _hoisted_13 = {
    key: 10,
    class: "create-game-expansion-icon expansion-icon-agendas"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = ["href"];
const _hoisted_16 = ["href"];
const _hoisted_17 = { class: "setup-item" };
const _hoisted_18 = {
    key: 0,
    class: "game-config generic"
};
const _hoisted_19 = { class: "setup-item" };
const _hoisted_20 = {
    key: 0,
    class: "game-config generic"
};
const _hoisted_21 = {
    key: 1,
    class: "game-config generic"
};
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { key: 1 };
const _hoisted_24 = { key: 2 };
const _hoisted_25 = { class: "setup-item" };
const _hoisted_26 = {
    key: 0,
    class: "game-config generic"
};
const _hoisted_27 = {
    key: 1,
    class: "game-config generic"
};
const _hoisted_28 = {
    key: 2,
    class: "game-config generic"
};
const _hoisted_29 = {
    key: 3,
    class: "game-config generic"
};
const _hoisted_30 = { key: 3 };
const _hoisted_31 = { class: "setup-item" };
const _hoisted_32 = {
    key: 0,
    class: "game-config generic"
};
const _hoisted_33 = {
    key: 1,
    class: "game-config generic"
};
const _hoisted_34 = {
    key: 2,
    class: "game-config generic"
};
const _hoisted_35 = { key: 3 };
const _hoisted_36 = { key: 4 };
const _hoisted_37 = { key: 5 };
const _hoisted_38 = { class: "setup-item" };
const _hoisted_39 = { class: "game-config generic" };
const _hoisted_40 = { key: 6 };
const _hoisted_41 = { class: "setup-item" };
const _hoisted_42 = { class: "game-config generic" };
const _hoisted_43 = {
    key: 0,
    class: "game-config generic"
};
const _hoisted_44 = {
    key: 1,
    class: "game-config generic"
};
const _hoisted_45 = { class: "setup-item" };
const _hoisted_46 = {
    key: 0,
    class: "game-config fastmode"
};
const _hoisted_47 = {
    key: 1,
    class: "game-config timer"
};
const _hoisted_48 = {
    key: 2,
    class: "game-config realtime-vp"
};
const _hoisted_49 = {
    key: 3,
    class: "game-config undo"
};
const _hoisted_50 = { key: 7 };
const _hoisted_51 = { class: "setup-item" };
const _hoisted_52 = { key: 8 };
const _hoisted_53 = { class: "setup-item" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("ul", null, [
            (0, vue_1.createElementVNode)("li", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                        (0, vue_1.createTextVNode)("Expansion:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (_ctx.gameOptions.expansions.venus)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 0,
                        href: _ctx.rulebookUrls.venus,
                        class: "tooltip",
                        "data-tooltip": "Venus Next rulebook",
                        target: "_blank"
                    }, [...(_cache[1] || (_cache[1] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-venus" }, null, -1)
                        ]))], 8, _hoisted_3))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.prelude)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 1,
                        href: _ctx.rulebookUrls.prelude,
                        class: "tooltip",
                        "data-tooltip": "Prelude rulebook",
                        target: "_blank"
                    }, [...(_cache[2] || (_cache[2] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-prelude" }, null, -1)
                        ]))], 8, _hoisted_4))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.prelude2)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 2,
                        href: _ctx.rulebookUrls.prelude2,
                        class: "tooltip",
                        "data-tooltip": "Prelude 2 rules",
                        target: "_blank"
                    }, [...(_cache[3] || (_cache[3] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-prelude2" }, null, -1)
                        ]))], 8, _hoisted_5))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.colonies)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 3,
                        href: _ctx.rulebookUrls.colonies,
                        class: "tooltip",
                        "data-tooltip": "Colonies rulebook",
                        target: "_blank"
                    }, [...(_cache[4] || (_cache[4] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-colony" }, null, -1)
                        ]))], 8, _hoisted_6))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.turmoil)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 4,
                        href: _ctx.rulebookUrls.turmoil,
                        class: "tooltip",
                        "data-tooltip": "Turmoil rulebook",
                        target: "_blank"
                    }, [...(_cache[5] || (_cache[5] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-turmoil" }, null, -1)
                        ]))], 8, _hoisted_7))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.promo)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 5,
                        href: _ctx.rulebookUrls.promo,
                        class: "tooltip",
                        "data-tooltip": "Promo cards rules",
                        target: "_blank"
                    }, [...(_cache[6] || (_cache[6] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-promo" }, null, -1)
                        ]))], 8, _hoisted_8))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.ares)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 6,
                        href: _ctx.rulebookUrls.ares,
                        class: "tooltip",
                        "data-tooltip": "Ares rules",
                        target: "_blank"
                    }, [...(_cache[7] || (_cache[7] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-ares" }, null, -1)
                        ]))], 8, _hoisted_9))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.moon)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 7,
                        href: _ctx.rulebookUrls.moon,
                        class: "tooltip",
                        "data-tooltip": "The Moon rules",
                        target: "_blank"
                    }, [...(_cache[8] || (_cache[8] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-themoon" }, null, -1)
                        ]))], 8, _hoisted_10))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.pathfinders)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 8,
                        href: _ctx.rulebookUrls.pathfinders,
                        class: "tooltip",
                        "data-tooltip": "Pathfinders rules",
                        target: "_blank"
                    }, [...(_cache[9] || (_cache[9] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-pathfinders" }, null, -1)
                        ]))], 8, _hoisted_11))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.community)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 9,
                        href: _ctx.rulebookUrls.community,
                        class: "tooltip",
                        "data-tooltip": "Community rules",
                        target: "_blank"
                    }, [...(_cache[10] || (_cache[10] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-community" }, null, -1)
                        ]))], 8, _hoisted_12))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.isPoliticalAgendasOn)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_13))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.ceo)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 11,
                        href: _ctx.rulebookUrls.ceo,
                        class: "tooltip",
                        "data-tooltip": "CEOs rules",
                        target: "_blank"
                    }, [...(_cache[11] || (_cache[11] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-ceo" }, null, -1)
                        ]))], 8, _hoisted_14))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.underworld)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 12,
                        href: _ctx.rulebookUrls.underworld,
                        class: "tooltip",
                        "data-tooltip": "Underworld rules",
                        target: "_blank"
                    }, [...(_cache[12] || (_cache[12] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-underworld" }, null, -1)
                        ]))], 8, _hoisted_15))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.expansions.starwars)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        key: 13,
                        href: _ctx.rulebookUrls.starwars,
                        class: "tooltip",
                        "data-tooltip": "Star Wars rules",
                        target: "_blank"
                    }, [...(_cache[13] || (_cache[13] = [
                            (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-starwars" }, null, -1)
                        ]))], 8, _hoisted_16))
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (0, vue_1.createElementVNode)("li", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_17, [...(_cache[14] || (_cache[14] = [
                        (0, vue_1.createTextVNode)("Board:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                    class: (0, vue_1.normalizeClass)(_ctx.boardColorClass)
                }, [
                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.gameOptions.boardName), 1)
                ], 2)), [
                    [_directive_i18n]
                ]),
                _cache[16] || (_cache[16] = (0, vue_1.createTextVNode)("   ", -1)),
                (_ctx.gameOptions.shuffleMapOption)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_18, [...(_cache[15] || (_cache[15] = [
                            (0, vue_1.createTextVNode)("(randomized tiles)", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (0, vue_1.createElementVNode)("li", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_19, [...(_cache[17] || (_cache[17] = [
                        (0, vue_1.createTextVNode)("WGT:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (_ctx.gameOptions.solarPhaseOption)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_20, [...(_cache[18] || (_cache[18] = [
                            (0, vue_1.createTextVNode)("On", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_21, [...(_cache[19] || (_cache[19] = [
                            (0, vue_1.createTextVNode)("Off", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
            ]),
            (_ctx.gameOptions.requiresVenusTrackCompletion)
                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_22, [...(_cache[20] || (_cache[20] = [
                        (0, vue_1.createTextVNode)("Require terraforming Venus to end the game", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.gameOptions.requiresMoonTrackCompletion)
                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_23, [...(_cache[21] || (_cache[21] = [
                        (0, vue_1.createTextVNode)("Require terraforming The Moon to end the game", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.playerNumber > 1)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_24, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_25, [...(_cache[22] || (_cache[22] = [
                            (0, vue_1.createTextVNode)("Milestones and Awards:", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (_ctx.gameOptions.randomMA === _ctx.RandomMAOptionType.NONE)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_26, [...(_cache[23] || (_cache[23] = [
                                (0, vue_1.createTextVNode)("Board-defined", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.gameOptions.randomMA === _ctx.RandomMAOptionType.LIMITED)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_27, [...(_cache[24] || (_cache[24] = [
                                (0, vue_1.createTextVNode)("Randomized with limited synergy", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.gameOptions.randomMA === _ctx.RandomMAOptionType.UNLIMITED)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_28, [...(_cache[25] || (_cache[25] = [
                                (0, vue_1.createTextVNode)("Full randomized", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.gameOptions.randomMA !== _ctx.RandomMAOptionType.NONE && _ctx.gameOptions.includeFanMA)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_29, [...(_cache[26] || (_cache[26] = [
                                (0, vue_1.createTextVNode)("Include fan Milestones/Awards", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true)
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.playerNumber > 1)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_30, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_31, [...(_cache[27] || (_cache[27] = [
                            (0, vue_1.createTextVNode)("Draft:", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (_ctx.gameOptions.initialDraftVariant)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_32, [...(_cache[28] || (_cache[28] = [
                                (0, vue_1.createTextVNode)("Initial", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.gameOptions.draftVariant)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_33, [...(_cache[29] || (_cache[29] = [
                                (0, vue_1.createTextVNode)("Research phase", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (!_ctx.gameOptions.initialDraftVariant && !_ctx.gameOptions.draftVariant)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_34, [...(_cache[30] || (_cache[30] = [
                                (0, vue_1.createTextVNode)("Off", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.gameOptions.preludeDraftVariant)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_35, "Prelude"))
                        : (0, vue_1.createCommentVNode)("", true)
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.gameOptions.escapeVelocity !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_36, [
                    _cache[31] || (_cache[31] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-escape-velocity" }, null, -1)),
                    (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.escapeVelocityDescription), 1)
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.gameOptions.expansions.venus && _ctx.gameOptions.removeNegativeGlobalEvents)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_37, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_38, [...(_cache[32] || (_cache[32] = [
                            (0, vue_1.createTextVNode)("Turmoil:", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_39, [...(_cache[33] || (_cache[33] = [
                            (0, vue_1.createTextVNode)("No negative Turmoil event", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.playerNumber === 1)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_40, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_41, [...(_cache[34] || (_cache[34] = [
                            (0, vue_1.createTextVNode)("Solo:", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_42, [
                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.lastSoloGeneration) + " Gens", 1)
                    ])), [
                        [_directive_i18n]
                    ]),
                    (_ctx.gameOptions.soloTR)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_43, [...(_cache[35] || (_cache[35] = [
                                (0, vue_1.createTextVNode)("63 TR", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_44, [...(_cache[36] || (_cache[36] = [
                                (0, vue_1.createTextVNode)("TR all", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("li", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_45, [...(_cache[37] || (_cache[37] = [
                        (0, vue_1.createTextVNode)("Game configs:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (_ctx.gameOptions.fastModeOption)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_46, [...(_cache[38] || (_cache[38] = [
                            (0, vue_1.createTextVNode)("fast mode", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.showTimers)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_47, [...(_cache[39] || (_cache[39] = [
                            (0, vue_1.createTextVNode)("timer", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.showOtherPlayersVP)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_48, [...(_cache[40] || (_cache[40] = [
                            (0, vue_1.createTextVNode)("real-time vp", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.gameOptions.undoOption)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_49, [...(_cache[41] || (_cache[41] = [
                            (0, vue_1.createTextVNode)("undo", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (_ctx.gameOptions.twoCorpsVariant)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_50, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_51, [...(_cache[42] || (_cache[42] = [
                            (0, vue_1.createTextVNode)("Merger", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.gameOptions.bannedCards.length > 0)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_52, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_53, [...(_cache[43] || (_cache[43] = [
                            (0, vue_1.createTextVNode)("Banned cards:", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.gameOptions.bannedCards.join(', ')), 1)
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ]));
}
